<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>订单填写提示管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :model="orderTip" :rules="rules" ref="orderTip" label-width="120px"  size="mini" :height="tableHeight">
                    <el-form-item label="载体名称" prop="carrierName" >
                        <el-input v-model="orderTip.carrierName" placeholder="请输入载体名称填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="样品编号" prop="sampleNum">
                        <el-input v-model="orderTip.sampleNum" placeholder="请输入样品编号填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="插入片段" prop="insertFragment">
                        <el-input v-model="orderTip.insertFragment" placeholder="请输入插入片段填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否存化" prop="isPurifying">
                        <el-input v-model="orderTip.isPurifying" placeholder="请输入是否存化填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="上游位点" prop="upstreamSite">
                        <el-input v-model="orderTip.upstreamSite" placeholder="请输入上游位点填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="下游位点" prop="downstreamSite">
                        <el-input v-model="orderTip.downstreamSite" placeholder="请输入下游位点填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否测序" prop="isSequencing">
                        <el-input v-model="orderTip.isSequencing" placeholder="请输入是否测序填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="送测公司" prop="sequenceCompany">
                        <el-input v-model="orderTip.sequenceCompany" placeholder="请输入送测公司填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="阳性克隆数" prop="positiveCloneNum">
                        <el-input v-model="orderTip.positiveCloneNum" placeholder="请输入阳性克隆数填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="测序引物名称" prop="sequencePrimerName">
                        <el-input v-model="orderTip.sequencePrimerName" placeholder="请输入测序引物名称填写提示" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="插入片段序列" prop="insertFragmentSeq">
                        <el-input v-model="orderTip.insertFragmentSeq" placeholder="请输入插入片段序列填写提示" clearable></el-input>
                    </el-form-item>
                    <el-row type="flex" style="justify-content: right;" class="button-row">
                        <el-button size="mini" type="primary" @click="submitForm()" :loading="loading">保存</el-button>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>

    export default {
        name:'User',
        components: {
        },
        data() {
            return {
                orderTip: {},
                direction: 'rtl',
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                currentUserId: "",
                rules: {
                },
                loading: false,
                tableHeight: "",//表格高度
            }
        },
        methods: {
            submitForm() {
                this.loading = true;
                this.$axios.post("/orderTip/save", this.orderTip).then(res => {
                    if (res.data.status === "success") {
                        this.$message({
                            message: "保存成功！",
                            type: "success"
                        });
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                }, error => {
                    this.$message.error(error.message);
                    this.loading = false;
                });
            },
            queryOrderTip() {
                this.$axios.post("/orderTip/find").then(
                    res=>{
                        if(res.data.status === "success"){
                            this.orderTip = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.loading = false;
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 160; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
            toLogin() {
                this.$router.push("/login");
            }
        },
        mounted() {
        },
        created() {
            this.getTableHeight();
            this.queryOrderTip();
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   /* .el-select {
        width: 360px;
    }

    .el-input {
        width: 360px;
    }
    .el-date-picker {
        width: 360px;
        background-color: green;
    }
    .el-cascader {
        width: 360px;
    }
    .el-input-number {
        width: 360px;
    } */
   .block {
       text-align: right;
       margin-top: 10px;
   }

    .box-card {
        width: 800px;
        position : absolute;
        margin-top: 20px;
        margin-left: 30%;
        
    }
    .bg {
        width: 100%;
        height: 100%;
        position: fixed;
        /* background: url("~@/assets/loginImage.png"); */
        background-size: 100% 100%;
    }
    .button-row {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
        
    }
    .button-row >.el-button {
        margin-top: 10px;
    }
</style>
